import { render, staticRenderFns } from "./InfoMoraReportTable.vue?vue&type=template&id=f20605ae&scoped=true"
import script from "./InfoMoraReportTable.vue?vue&type=script&lang=js"
export * from "./InfoMoraReportTable.vue?vue&type=script&lang=js"
import style0 from "./InfoMoraReportTable.vue?vue&type=style&index=0&id=f20605ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20605ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
